import type { FC } from 'react';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import Button from '@atlaskit/button/standard-button';

import { MoreButtonContainer } from './PresentationalComponents.tsx';

type ViewMoreProps = {
	hasMore?: boolean;
	loading?: boolean;
	fetchMore: () => void;
};

const i18n = defineMessages({
	viewMore: {
		id: 'space-views.view.more',
		defaultMessage: 'View more',
		description:
			'text that appears in the viewMore buton at the bottom of the flat pages list shown in the sidebar when that have been filtered by the menu in the pages link',
	},
});

export const ViewMoreButton: FC<ViewMoreProps> = ({ fetchMore, hasMore, loading }) => {
	return !loading && hasMore ? (
		<MoreButtonContainer>
			<Button spacing="compact" shouldFitContainer onClick={fetchMore}>
				<FormattedMessage {...i18n.viewMore} />
			</Button>
		</MoreButtonContainer>
	) : null;
};
